import React, { useEffect, useRef, useState } from 'react'
import Logo from "../../Assets/Images/logo.png"
import { Input, notification } from 'antd'
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import config, { axiosInstance } from '../Config';
import secureLocalStorage from 'react-secure-storage';
import swal from 'sweetalert';
import AccountContainer from './AccountContainer';

const ForgotPassword = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [isOtpSent, setIsOtpSent] = useState(false);

    useEffect(() => {
        const credential = secureLocalStorage.getItem('credentials')
        try {
            if (credential) {
                if (('id' in credential) && ('name' in credential) && ('email' in credential)) {
                    navigate(`${config.appUrl}`);
                }
            }
        } catch (error) {
            console.log(error)
        }
    }, []);

    const onSendOtp = async (e) => {
        e.preventDefault();
        try {
            if (email) {
                setLoading(true);
                const formData = new FormData()
                formData.append('email', email)
                formData.append("type",0);

                const response = await axiosInstance.post(`/forgot-password`, formData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    }
                })

                if (response.data.success == true) {

                    notification.open({
                        message: (
                            <div className="d-flex">
                                <div className="pr-10">
                                    <i
                                        className="icon-check text-success"
                                        style={{ fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div>Otp Sent Successfully.</div>
                            </div>
                        ),
                        description: "OTP has been sent to your Email Address !",
                    });

                    const res_data = {
                        otp: response.data.otp,
                        email: response.data.instructor.email,
                        name: response.data.instructor.name
                    }

                    secureLocalStorage.setItem('temp_data', res_data)

                    setIsOtpSent(true)
                }
                else {
                    notification.open({
                        message: (
                            <div className="d-flex">
                                <div className="pr-10">
                                    <i
                                        className="icon-warning text-danger"
                                        style={{ fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div>Opp! Something went wrong.</div>
                            </div>
                        ),
                        description: "Invalid Email Address!",
                    });
                }
                setLoading(false);
            }
            else {
                notification.open({
                    message: (
                        <div className="d-flex">
                            <div className="pr-10">
                                <i
                                    className="icon-warning text-danger"
                                    style={{ fontSize: "20px" }}
                                ></i>
                            </div>
                            <div>Please Enter Email Id</div>
                        </div>
                    ),
                    description: "Email and Password are required",
                });
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
            swal("", "Something went wrong!", "error")
        }
    };

    // otp fields
    const length = 6
    const [otpValues, setOtpValues] = useState(Array(length).fill(''));
    const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null) , useRef(null) , useRef(null)];

    const handleInputChange = (index, event) => {
        const { value } = event.target;
        const newValues = [...otpValues];
        newValues[index] = value;
        setOtpValues(newValues);

        // Move to the next input when a digit is entered
        if (value !== '' && index < length - 1) {
            inputRefs[index + 1].current.focus();
        }
    };

    const handleBackspace = (index, event) => {
        if (event.keyCode === 8 && index > 0 && otpValues[index] === '') {
            inputRefs[index - 1].current.focus();
        }
    };

    const handleCompareOtp = async (e) => {
        e.preventDefault()
        const user_info = secureLocalStorage.getItem('temp_data')

        // 
        if (otpValues.join('') == user_info.otp) {

            notification.open({
                message: (
                    <div className="d-flex">
                        <div className="pr-10">
                            <i
                                className="icon-check text-success"
                                style={{ fontSize: "20px" }}
                            ></i>
                        </div>
                        <div>Otp Verified Successfully!</div>
                    </div>
                ),
                description: "Now You Can Reset Your Password."
            });

            setTimeout(() => {
                navigate(`${config.appUrl}reset-password`)
            }, 1000)

        } else {
            notification.open({
                message: (
                    <div className="d-flex">
                        <div className="pr-10">
                            <i
                                className="icon-warning text-danger"
                                style={{ fontSize: "20px" }}
                            ></i>
                        </div>
                        <div>Invalid Otp</div>
                    </div>
                ),
                description: "Please check you email properly.",
            });
        }

    }

    return (
        <div>
            {isLoading && (<Loader />)}

            <AccountContainer>
                {
                    !isOtpSent ?
                        // forgot
                        <form onSubmit={onSendOtp} className='px-md-5'>
                            <div className="ps-form__content px-5 pt-5">
                                <div className='text-center mb-4'>
                                    <img src={Logo} alt='No Logo' className='img-fluid w-50' />
                                </div>
                                <h5 className="mt-5 pt-md-4 display-4 fw-semibold text-center mb-2">Forgot Password ?</h5>
                                <p className="mb-5 text-center">Reset It Using Your Email Address</p>
                                {/* <h5 className=" fs-2 text-center"></h5>
                                <p className="pb-20 text-center"></p> */}
                                <div className="form-group form-forgot">
                                    {/* <label htmlFor="" className='text-uppercase'>Email Address</label> */}
                                    <Input
                                        className="form-control form-field"
                                        type="email"
                                        placeholder="Enter Your Email"
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value)
                                            setError(false)
                                        }}
                                        required
                                    />
                                </div>

                                <div className="form-group mt-5 ">
                                    <button
                                        type="submit"
                                        className="ps-btn ps-btn--fullwidth btn-green py-4 color-white"
                                    >
                                        Verify Email
                                    </button>
                                </div>

                                <div className="ps-checkbox text-center mt-5 fs-4">
                                    Back to <Link to={`${config.appUrl}login`} className="text-green">Login</Link>
                                </div>
                            </div>
                        </form>
                        :
                        // otp
                        <form onSubmit={handleCompareOtp}>
                            <div className="ps-form__content px-5 pt-5">
                                <div className='text-center mb-4'>
                                    <img src={Logo} alt='No Logo' className='img-fluid w-50' />
                                </div>
                                <h5 className=" fs-2 text-center">Please Check Your Email</h5>
                                <p className="pb-20 text-center">We've Sent Otp
                                    <span className='text-green'>{" "}{secureLocalStorage.getItem('temp_data')?.email}</span></p>
                                <div className="form-group form-forgot">
                                    <div className="text-center">

                                        {otpValues.map((value, index) => (
                                            <input
                                                key={index}
                                                ref={inputRefs[index]}
                                                type="text"
                                                className='fs-3 form-otp-field bg-white text-center text-dark py-2 border shadow-sm'
                                                maxLength={1}
                                                value={value}
                                                placeholder='0'
                                                onChange={(e) => handleInputChange(index, e)}
                                                onKeyDown={(e) => handleBackspace(index, e)}
                                                required
                                            />
                                        ))}

                                    </div>
                                </div>

                                <div className="form-group mt-5 ">
                                    <button
                                        type="submit"
                                        className="ps-btn ps-btn--fullwidth py-4 btn-green color-white"
                                    >
                                        Verify Otp
                                    </button>
                                </div>

                                <div className="ps-checkbox text-center mt-5 fs-4 pt-5">
                                    Back to <Link to={`${config.appUrl}login`} className="text-green">Login</Link>
                                </div>
                            </div>
                        </form>
                }
            </AccountContainer>
        </div>
    )
}

export default ForgotPassword